import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Microservices } from 'src/app/core/constants/pol.enums';
import { IHomeContentResponse } from './state/home.model';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  constructor(private http: HttpClient) {
  }

  getMpCardsContent() {
    const apiUrl = `${Microservices.UmbracoCMS}/ContentData/3a7887aa-2a62-4ad3-bda0-093f81cd8980`;
    return this.http.get<IHomeContentResponse>(apiUrl).pipe(
      map((response: IHomeContentResponse) => {
        return response.contents;
      })
    );
  }

  getAnnouncements() {
    const apiUrl = `${Microservices.UmbracoCMS}/ContentData/6d51b597-b95d-4b43-96b6-80b0f1747681`;
    return this.http.get<IHomeContentResponse>(apiUrl).pipe(
      map((response: IHomeContentResponse) => {
        return response.contents;
      })
    );
  }

  getMpCardDetails(mpCardId) {
    const apiUrl = `${Microservices.UmbracoCMS}/ContentData/${mpCardId}`;
    return this.http.get<IHomeContentResponse>(apiUrl).pipe(
      map((response: IHomeContentResponse) => {
        return response.contents;
      })
    );
  }
  getHomeContent(): Observable<{ heading: string; body: string; }> {
    const apiUrl = `${Microservices.UmbracoCMS}/ContentData/59e93844-4c15-44f3-914f-3305f0e98a44`;
    return this.http.get<IHomeContentResponse>(apiUrl).pipe(
      map((response: IHomeContentResponse) => {
        const {heading, body} = response.contents[0].value;
        return {
          heading,
          body
        }
      })
    );
  }
}
